const isLocal = false;
const liveChatHost = isLocal ? window.config.serverUrl : window.config.imRestURL;
const liveChatPort = window.config.liveChatPort;
const liveChatLocalServerUrl = `${liveChatHost}:${liveChatPort}`;

export function getSignalingUrl(peerId, roomId) {
  const hostname = window.config.serverUrl;
  const port =
      process.env.NODE_ENV !== "production"
          ? window.config.developmentPort
          : window.config.productionPort;
  return `wss://${hostname}:${port}/?peerId=${peerId}&roomId=${roomId}`;
}

export function getLiveChatServerRestApiUrl() {
  return isLocal
      ? `https://${liveChatLocalServerUrl}`
      : `https://${liveChatHost}`;
}

export function getLiveChatServerSocketUrl() {
  return isLocal
      ? `ws://${liveChatLocalServerUrl}`
      : `wss://${window.config.imServerURL}`;
}


